import React from 'react'
import HomeProfile from './HomeProfile'
import PostBox from '../PostBox/PostBox'
import { Padding } from '@mui/icons-material'
import { Box, Grid } from '@mui/material'
import SidebarUserList from './SidebarUserList'
import EventsSideBar from './EventsSideBar'
import { useSelector } from 'react-redux'
import SearchBox from './SearchBox'

// import PostBox from './PostBox'

const HomePage = () => {
  const searchActive = useSelector((state) => state.search.searchActive);

  return (
    <Box sx={{ Padding: 2 }}>

      <Grid container spacing={2}>
        {/* Main Section */}
        <Grid
          item
          size={{ md: 8.5, xs: 12, sm: 12 }}
        >
          {/* <HomeProfile />
          <PostBox /> */}
          {searchActive ? <SearchBox /> : <><HomeProfile /> <PostBox /></>}
        </Grid>

        {/* Side Content */}
        <Grid item
          size={{ md: 3.5, xs: 12, sm: 12 }} sx={{
            // background: "white",
            height: "fit-content"
          }}>
          <EventsSideBar />

          <SidebarUserList />
        </Grid>
      </Grid>
    </Box>
  )
}

export default HomePage